import products from '@/api/apiSferest/services/products'

export const set = ({ commit, state }, product) => {
  return new Promise((resolve) => {
    commit('SET_ID', product.id)
    commit('SET_VENDORCODE', product.vendor)
    commit('SET_PAYERCODE', product.payer)
    commit('SET_DESCRIPTION', product.description)
    commit('SET_PRICEBATCH', product.totalAmount)
    commit('SET_UNIT', product.unit)
    commit('SET_BATCHUNITS', product.count)
    resolve(state)
  })
}

export const get = ({ dispatch }, id) => {
  return new Promise((resolve, reject) => {
    if (!id) reject(new Error('Id must be provided'))
    products.get(id)
    .then(res => {
      dispatch('set', res.data)
      .then(product => {
        resolve(product)
      })
    })
  })
}

export const create = ({ getters }) => {
  return new Promise((resolve, reject) => {
    let product = getters.apificate
    if (product.id) delete product.id
    products.create(product)
    .then((res) => {
      resolve(product)
    })
  })
}

export const update = ({ getters }, _id) => {
  return new Promise((resolve, reject) => {
    let product = getters.apificate
    products.update(_id, product)
    .then((res) => {
      resolve(product)
    })
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_ID', undefined)
    commit('SET_VENDORCODE', undefined)
    commit('SET_PAYERCODE', undefined)
    commit('SET_DESCRIPTION', undefined)
    commit('SET_PRICEBATCH', undefined)
    commit('SET_UNIT', 'EUR')
    commit('SET_BATCHUNITS', undefined)
    resolve()
  })
}
